window.countdowntitle = "ENDS IN";
window.countdowntag = "";
window.countdown_product = "false";
window.decal_only = "false";

var timer;

function CountDownTimer(dt, id) {
  var end = new Date(dt);

  var _second = 1000;
  var _minute = _second * 60;
  var _hour = _minute * 60;
  var _day = _hour * 24;
  var timer;

  function showRemaining() {
    var now = new Date();
    var distance = end - now;
    let CC = document.querySelectorAll(".countdowncontainer");

    if (distance < 1000) {
      for (let i = 0; i < CC.length; i++) {
        CC[i].style.display = "none";
      }
      $(".newcountdown").html("");
      return;
    } else {
      $(".countdown-decal").show();

      for (let i = 0; i < CC.length; i++) {
        CC[i].style.opacity = "1";
      }

      const days = Math.floor(distance / _day);
      const hours =  Math.floor((distance % _day) / _hour)
      const minutes = Math.floor((distance % _hour) / _minute);
      const seconds = Math.floor((distance % _minute) / _second);

      const timeRemaining = [
        days > 0 ? days + "D" : "",
        hours > 0 || days > 0 ? String(hours).padStart(2, "0")  + "H" : "",
        String(minutes).padStart(2, "0") + "M",
        String(seconds).padStart(2, "0") + "S"
      ].filter(Boolean).join(" ");


      $("#countdown-announcement-slide .announcement-subcontent span:first-child").html("ENDS IN ");
      $("#countdown-announcement-slide .announcement-content").html("" );
      $("#countdown-announcement-slide").attr( "href","https://thegymking.com/collections/spring-sale");
      $("." + id).html(timeRemaining);
    }
  }

  timer = setInterval(showRemaining, 50);
}

let endDate = "05/28/25 09:00 AM" + getTimeZone();
CountDownTimer(endDate, "newcountdown");

function getTimeZone() {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    timeZoneName: "short",
  });

  const parts = formatter.formatToParts(new Date());
  let timeZone = parts.find((part) => part.type === "timeZoneName").value;
  timeZone == "BST" ? (timeZone = " GMT+0100 (BST)") : (timeZone = " GMT+0000 (Greenwich Mean Time)");
  return timeZone; // Outputs "BST" or "GMT"
}
